import { Grid, TextField } from "@material-ui/core";
import { useFormik } from "formik";
import React from "react";
import * as yup from "yup";
import { HistoryBackButton, SubmitButton } from "components/buttons";

const validationSchema = yup.object({
  propertyName: yup.string().required(),
  propertyLogo: yup.string(),
  timezone: yup.string(),
  physicalAddress: yup.object({
    street: yup.string().required(),
    street2: yup.string(),
    city: yup.string().required(),
    state: yup.string().required(),
    zip: yup.string().required(),
  }).required(),
  addressIsScattered: yup.boolean().required(),
  mailingIsPhysical: yup.boolean().required(),
  mailingIsOrganization: yup.boolean().required(),
  mailingAddress: yup.object({
    street: yup.string().required(),
    street2: yup.string(),
    city: yup.string().required(),
    state: yup.string().required(),
    zip: yup.string()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(5, "Must be exactly 5 digits")
      .max(5, "Must be exactly 5 digits")
      .required(),
  }).required(),
  contactPhone: yup.string().required(),
  contactEmail: yup.string().required(),
  respondToEmail: yup.string().required(),
  footer504: yup.string().required(),
});

const emptyValues = {
  propertyName: "",
  propertyLogo: "",
  timezone: "",
  physicalAddress: {
    street: "",
    street2: "",
    city: "",
    state: "",
    zip: "",
  },
  addressIsScattered: false,
  mailingIsPhysical: false,
  mailingIsOrganization: false,
  mailingAddress: {
    street: "",
    street2: "",
    city: "",
    state: "",
    zip: "",
  },
  contactPhone: "",
  contactEmail: "",
  respondToEmail: "",
  footer504: "",
};
type FormValues = typeof emptyValues;
type FormPropsType = {
  initialValues?: FormValues,
  submitForm: (input: any) => void
}


const PropertyForm: React.FC<FormPropsType> = ({ submitForm, initialValues = emptyValues }) => {
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
      submitForm(values);
    },
  });
  const {
    values,
    handleSubmit,
    handleChange,
    touched,
    errors,
  } = formik;
  const fieldInput = (key: keyof FormValues, label: string) => <TextField
    variant="outlined"
    fullWidth
    id={key}
    name={key}
    label={label}
    value={values[key]}
    onChange={handleChange}
    error={touched[key] && Boolean(errors[key])}
    helperText={touched[key] && errors[key]}
  />;
  return <form onSubmit={handleSubmit}>
    <Grid container spacing={2}>
      <Grid container item xs={12}>
        {fieldInput("propertyName", "Property Name")}
      </Grid>
      <Grid container item xs={12}>
        {fieldInput("propertyLogo", "Property Logo")}
      </Grid>
      <Grid container item xs={12}>
        {fieldInput("timezone", "Timezone")}
      </Grid>
      <Grid container item xs={12} justifyContent="flex-end">
        <Grid item>
          <HistoryBackButton />
          <SubmitButton
            text="Continue"
            loadingText="Sending"
          />
        </Grid>
      </Grid>
    </Grid>
  </form>;
};
export default PropertyForm;
